import React, { useEffect } from "react";
import "./HerbalScienceModal.css";

const HerbalScienceModal = ({ isOpen, onClose }) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="hm-overlay" onClick={onClose}>
      <div className="hm-container" onClick={(e) => e.stopPropagation()}>
        <button className="hm-close" onClick={onClose}>&times;</button>

        <div className="hm-content">
          {/* Left — Image */}
          <div className="hm-image">
            <img
              src="https://storage.googleapis.com/rasai-nutrie-assets/tiles/tile-3.png"
              alt="The Missing Link: Real Food"
            />
          </div>

          {/* Right — Text */}
          <div className="hm-text">
            <h1>THE MISSING LINK: REAL FOOD</h1>

            <p>
              Modern food systems, environmental depletion, lifestyle stress, and variability
              in nutrient bioavailability mean that dietary intake does not always translate
              to cellular sufficiency. At the same time, modern foods often lack the diversity
              and concentration of bioactive compounds present in traditional whole foods,
              creating a subtle gap between consumption and biological nourishment.
            </p>

            <p>
              At RASAI NUTRIE, we believe healing happens when the body is supported, not
              overridden. True restoration begins at the gut and cellular level where digestion,
              absorption, lipid metabolism, and cellular signaling shape how the entire body
              functions.
            </p>

            <p>
              Whole foods contain complex networks of nutrients and phytochemicals that work
              together to support biological systems. When consumed in the right combinations,
              plants, herbs, and natural foods provide:
            </p>

            <ul className="hm-bullets">
              <li>Micronutrients</li>
              <li>Polyphenols</li>
              <li>Antioxidants</li>
              <li>Metabolic regulators</li>
            </ul>

            <p>
              These compounds interact with biological pathways that regulate inflammation,
              metabolism, and cellular protection.
            </p>

            <blockquote className="hm-quote">
              "Physiological restoration is gradual, yet it supports lasting improvements in
              digestive function, metabolic stability, sleep regulation, and systemic resilience."
            </blockquote>

            <button className="hm-back-btn" onClick={onClose}>Back to Home</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HerbalScienceModal;
